import { API } from "../../constants/APIConstants";
import { OPERATION_STATUS } from "../../config/axios.init";
import { callAPI } from "../../config/AxiosTemplate";
import { CLEAR_BASIC_INFORMATION_DATA, CLEAR_CREDIT_PRODUCT_INPUT_DATA, CLEAR_CREDIT_PRODUCT_INPUT_DATA_FOR_EDIT, CLEAR_EVIDENCE_DATA, CLEAR_FINANCIAL_INFORMATION_DATA, CLEAR_REFERENCES_DATA, CLEAR_SET_ALL_LOAN_DETAILS, CLEAR_SITE_VISIT_DATA, SET_ALL_LOAN_DETAILS, SET_APPLY_LOAN_CONFIG_DATA, SET_BASIC_INFORMATION_DATA, SET_CREDIT_PRODUCT_INPUT_DATA, SET_CREDIT_PRODUCT_INPUT_DATA_FOR_EDIT, SET_EVIDENCE_DATA, SET_FINANCIAL_INFORMATION_DATA, SET_INCOME_DATA, SET_REFERENCES_DATA, SET_SITE_VISIT_DATA, UPDATE_DOC_REQUIRE_CONFIG, UPDATE_DOCPREFILL_DATA, UPDATE_INVALID_FORM_FIELD } from "../../redux/constants";
import { Strings } from "../../resources/i18n/i18n";

export const getAllInvoicesForMinimartAction = (request, callBack) => {

  callAPI(
    "getAllInvoicesForMinimart",
    API.getInvoices,
    "POST",
    request,
    (apiResponse) => {
      callBack(apiResponse);
    }
  );

}

export const calculateEMIAction = (request, callBack) => {
  let requestString = API.calculateEMI.concat(request.minimartId + "&term=" + request.term + "&loanType=" + request.loanType + "&amount=" + request.amount + "&frequency=" + request.frequency + "&collectionDays="
    + request.collectionDays);
  callAPI(
    "calculateEMI",
    requestString,
    "GET",
    {},
    (apiResponse) => {
      callBack(apiResponse);
    }
  )
}

export const poorGradesAction = (callBack) => {
  callAPI(
    "poorGrades",
    API.poorGrades,
    "GET",
    {},
    (apiResponse) => {
      callBack(apiResponse);
    }
  )
}

export const getLastDisbursedLoanIdAction = (request, callBack) => {
  let requestString = API.getLastDisbursedLoanId + request;
  callAPI(
    "getLastDisbursedLoan",
    requestString,
    "GET",
    {},
    (apiResponse) => {
      callBack(apiResponse);
    }
  )
}

export const getLastLoanDetailsAction = (request, callBack) => {
  let requestString = API.getLastDisbursedLoanId + request + "/loan";
  callAPI(
    "getLastLoanDetails",
    requestString,
    "GET",
    {},
    (apiResponse) => {
      callBack(apiResponse)
    }
  )
}

export const createLoanAction = (request, callBack) => {
  callAPI(
    "createLoan",
    API.createLoan,
    "POST",
    request,
    (apiResponse) => {
      callBack(apiResponse)
    }
  )
}

export const suggestedAmountAction = (request, callBack) => {
  let requestString = API.suggestedAmount + request.mid;
  let requestData = {
    type: request.type
  }
  callAPI(
    "suggestedAmount",
    requestString,
    "POST",
    requestData,
    (apiResponse) => {
      callBack(apiResponse)
    }
  )
}

export const cedulaValidateAction = (request, callBack) => {
  let requestString = API.cedulaValidate + "oid=" + request.ownerId + "&aid=" + request.loanApplicationId;

  callAPI(
    "cedulaValidate",
    requestString,
    "GET",
    {},
    (apiResponse) => {
      callBack(apiResponse)
    }
  )
}

export const loanUpdateAction = (request, callBack) => {
  callAPI(
    "loanUpdate",
    API.loanUpdate,
    "PUT",
    request,
    (apiResponse) => {
      callBack(apiResponse)
    }
  )
}
export const updateDocRequireConfigAction = (documentStatus) => (dispatch) => {
  
  dispatch({
    type: UPDATE_DOC_REQUIRE_CONFIG,
    documentStatus: documentStatus,
  });
}
export const updateInvalidFormFieldAction = (loanStep) => (dispatch) => {
  
  dispatch({
    type: UPDATE_INVALID_FORM_FIELD,
    loanStep: loanStep,
  });
}
export const setApplyLoanConfigAction = (applyLoanConfig) => (dispatch) => {
  dispatch({
    type: SET_APPLY_LOAN_CONFIG_DATA,
    applyLoanConfig: applyLoanConfig,
  });
}
export const setCreditProductInputDataForEditAction = (creditProductInputDataForEdit) => (dispatch) => {
  dispatch({
    type: SET_CREDIT_PRODUCT_INPUT_DATA_FOR_EDIT,
    creditProductInputDataForEdit: creditProductInputDataForEdit,
  });
}
export const setLoanDetailsAction = (loanDetails) => (dispatch) => {
  
  dispatch({
    type: SET_ALL_LOAN_DETAILS,
    allLoanDetails: loanDetails,
  });
};

export const setCreditProductValuesAction = (inputData) => (dispatch) => {
  
  dispatch({
    type: SET_CREDIT_PRODUCT_INPUT_DATA,
    loanInfo: inputData,
  });
}
export const setBasicInformationValuesAction = (inputData) => (dispatch) => {
  dispatch({
    type: SET_BASIC_INFORMATION_DATA,
    basicInfo: inputData,
  });
}
export const setReferencesValuesAction = (inputData) => (dispatch) => {
  dispatch({
    type: SET_REFERENCES_DATA,
    additionalInfo: inputData,
  });
}
export const setFinancialInformationAction = (inputData) => (dispatch) => {
  dispatch({
    type: SET_FINANCIAL_INFORMATION_DATA,
    expenses: inputData,
  });
}
export const setIncomeDataAction = (inputData) => (dispatch) => {
  
  dispatch({
    type: SET_INCOME_DATA,
    income: inputData,
  });
}
export const setSiteVisitAction = (inputData) => (dispatch) => {
  dispatch({
    type: SET_SITE_VISIT_DATA,
    siteVisit: inputData,
  });
}
export const setEvidenceAction = (inputData) => (dispatch) => {
  dispatch({
    type: SET_EVIDENCE_DATA,
    documents: inputData,
  });
}
export const clearLoanDetailsAction = () => (dispatch) => {
  dispatch({
    type: CLEAR_SET_ALL_LOAN_DETAILS,
  });
};

export const clearsetCreditProductValuesAction = () => (dispatch) => {
  dispatch({
    type: CLEAR_CREDIT_PRODUCT_INPUT_DATA,
  });
}
export const clearCreditProductInputDataForEditAction = () => (dispatch) => {
  dispatch({
    type: CLEAR_CREDIT_PRODUCT_INPUT_DATA_FOR_EDIT,
  });
}
export const clearsetBasicInformationValuesAction = () => (dispatch) => {
  dispatch({
    type: CLEAR_BASIC_INFORMATION_DATA,
  });
}
export const clearsetReferencesValuesAction = () => (dispatch) => {
  dispatch({
    type: CLEAR_REFERENCES_DATA,
  });
}
export const clearsetFinancialInformationAction = () => (dispatch) => {
  dispatch({
    type: CLEAR_FINANCIAL_INFORMATION_DATA,
  });
}
export const clearsetSiteVisitAction = () => (dispatch) => {
  dispatch({
    type: CLEAR_SITE_VISIT_DATA,
  });
}
export const clearsetEvidenceAction = () => (dispatch) => {
  dispatch({
    type: CLEAR_EVIDENCE_DATA,
  });
}


export const uploadEvidenceDocumentAction = (request, callback) => {
  // Convert blob URL back to file object
  const fetchFileFromBlobUrl = async (blobUrl) => {
    try {
      const response = await fetch(blobUrl);
      const blob = await response.blob();
      return new File([blob], request.fileName, { type: request.fileMimeType });
    } catch (error) {
      throw error;
    }
  };

  // Use async/await to handle the file conversion
  fetchFileFromBlobUrl(request.fileUri).then(file => {
    const requestData = new FormData();
    requestData.append("applicationId", request.applicationId);
    requestData.append("type", request.type);
    requestData.append("fileType", request.fileType);
    requestData.append("file", file);

    callAPI(
      "uploadEvidenceDocument",
      API.fileUpload,
      "POST",
      requestData,
      (apiResponse) => {
        callback(apiResponse);
      }, false, true
    );
  }).catch(error => {
    callback({
      status: OPERATION_STATUS.FAILURE,
      error: { message: Strings("failedToUploadFile") }
    });
  });
};

export const loanValidateAction = (request, callback) => {
  let requestString = API.loanValidate + "appId=" + request;
  callAPI(
    "loanValidate",
    requestString,
    "GET",
    {},
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

export const updateLoanStatusAction = (request, callback) => {
  callAPI(
    "updateLoanStatus",
    API.updateLoanStatusForDisburment,
    "PATCH",
    request,
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

export const updateDocPrefillDataAction = (docPrefillData) => (dispatch) => {
  dispatch({
    type: UPDATE_DOCPREFILL_DATA,
    docPrefillData: docPrefillData,
  });
}